import React from "react";
import Container from "./Container";
import { Building2, Sparkles, Briefcase } from "lucide-react";
import { useNavigate } from "react-router-dom";

const pillars = [
  {
    Icon: Building2,
    title: "Wide range of properties",
    body: "Our customers have a wide range of options to choose from and they are all verified by our team.",
  },
  {
    Icon: Sparkles,
    title: "Seamless experience",
    body: "We ensure a smooth process, from property selection to confirmation and move-in, providing our clients with the best possible service.",
  },
  {
    Icon: Briefcase,
    title: "Transaction services",
    body: "Transaction services are offered with a holistic approach to ensure that business efficiency and cost savings are fulfilled for clients.",
  },
];

function Apart() {
  const navigate = useNavigate();

  return (
    <section className="relative z-[1] -mt-6 mb-16 overflow-hidden py-4 md:-mt-8 md:mb-24 md:py-6 padingm">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-slate-100/80 to-transparent"
        aria-hidden
      />
      <Container className="relative max-w-6xl px-4 md:px-6">
        <div className="overflow-hidden rounded-2xl border border-slate-200/90 bg-gradient-to-br from-[#F0F9FF] via-white to-slate-50/80 shadow-[0_12px_40px_rgba(15,23,42,0.06)] ring-1 ring-black/[0.03]">
          <div className="flex flex-col gap-5 border-b border-slate-200/60 bg-white/50 px-5 py-6 backdrop-blur-sm sm:flex-row sm:items-center sm:justify-between sm:px-8 sm:py-8 md:px-10">
            <div className="flex min-w-0 items-start gap-4">
              <div
                className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#FECE51]/25 text-[#0F172A] ring-1 ring-[#FECE51]/40"
                aria-hidden
              >
                <Sparkles className="h-6 w-6" strokeWidth={1.75} />
              </div>
              <div>
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#727272]">
                  Why choose us
                </p>
                <h2 className="mt-1 text-[#0F172A]">What sets us apart?</h2>
                <p className="mt-1.5 max-w-xl text-[14px] leading-relaxed text-[#727272]">
                  Go from borrowing to buying—with clarity at every step.
                </p>
                <hr className="mt-3 h-1 w-20 rounded-full bg-[#FECE51]" />
              </div>
            </div>
            <button
              type="button"
              onClick={() => navigate("/Property")}
              className="shrink-0 rounded-xl border-2 border-[#FECE51] bg-white px-5 py-2.5 text-[11px] font-bold uppercase tracking-wide text-[#0F172A] shadow-sm transition hover:bg-[#FECE51] hover:text-[#0F172A] md:px-7"
            >
              View all list
            </button>
          </div>

          <div className="grid gap-4 p-4 sm:grid-cols-2 sm:p-5 lg:grid-cols-3 lg:gap-5 lg:p-8">
            {pillars.map(({ Icon, title, body }) => (
              <article
                key={title}
                className="flex flex-col rounded-xl border border-slate-200/80 bg-white p-6 shadow-sm transition hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-md md:p-7"
              >
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-[#F0F9FF] text-[#0F172A] ring-1 ring-sky-100">
                  <Icon className="h-5 w-5" strokeWidth={1.75} aria-hidden />
                </div>
                <h3 className="text-left text-[11px] font-bold uppercase tracking-wide text-[#FECE51] md:text-xs">
                  {title}
                </h3>
                <p className="mt-2 text-left text-[13px] leading-relaxed text-[#727272] md:text-[14px]">
                  {body}
                </p>
              </article>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Apart;
